export default __webpack_public_path__ + "static/media/info_icon.56f4f6be.svg";